import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { Callout, Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

export const Title = ({
  upgrade,
  ...props
}: {
  type: "style" | "model";
  subtype: "avatar" | "animal" | "object" | "car" | "style" | "none";
  name: string;
  upgrade?: boolean;
}) => {
  const { t } = useTranslation();
  const minPhotoCount = 20;
  return (
    <div>
      {!upgrade && props.subtype === "none" && (
        <Heading size="8" className="mb-4">
          {props.type === "style"
            ? t("loras.type.createStyle", "Créons votre style")
            : t("loras.type.createModel", "Créons votre modèle")}
        </Heading>
      )}

      {!upgrade && props.subtype !== "none" && (
        <Heading size="6" className="mb-4">
          {props.type === "model" && props.subtype !== "avatar" && (
            <>
              {t("loras.upload.title", {
                replace: {
                  type: (
                    {
                      animal: t("loras.type.types.animal.name")?.toLowerCase(),
                      object: t("loras.type.types.object.name")?.toLowerCase(),
                      car: t("loras.type.types.car.name")?.toLowerCase(),
                      style: t("loras.type.types.style.name")?.toLowerCase(),
                    } as any
                  )[props.subtype],
                  count: minPhotoCount,
                },
              })}
            </>
          )}
          {props.type === "model" && props.subtype === "avatar" && (
            <>
              {props.name
                ? t("loras.upload.title_avatar", {
                    replace: { name: props.name, count: minPhotoCount },
                  })
                : t("loras.upload.title_avatar_no_name", {
                    replace: { count: minPhotoCount },
                  })}
            </>
          )}
          {props.type !== "model" && (
            <>
              {t("loras.upload.title_style", {
                replace: { count: minPhotoCount },
              })}
            </>
          )}
        </Heading>
      )}

      {upgrade && (
        <Heading size="6" className="mb-4">
          {t("loras.type.upgradeTitle")}
        </Heading>
      )}

      <Text className="block mb-6">
        {props.type === "model"
          ? t("loras.upload.model_description")
          : t("loras.upload.style_description")}
      </Text>
    </div>
  );
};

export const Guidelines = (props: {
  type: "style" | "model";
  subtype: "avatar" | "animal" | "object" | "car" | "style" | "none";
}) => {
  const { t } = useTranslation();
  return (
    <>
      {props.type === "style" && (
        <Callout.Root className="mt-8">
          <Callout.Icon>
            <InformationCircleIcon className="h-4 w-4" />
          </Callout.Icon>
          <Callout.Text>{t("loras.upload.style_callout")}</Callout.Text>
        </Callout.Root>
      )}

      {props.subtype === "car" && (
        <Callout.Root className="mt-8 overflow-hidden">
          <Callout.Icon>
            <InformationCircleIcon className="h-4 w-4" />
          </Callout.Icon>
          <Callout.Text>
            {t("loras.upload.car_callout")}
            <div className="flex space-x-4">
              <video
                src="/videos/car_demo_1.mp4"
                className="mt-4 rounded-md h-24"
                autoPlay
                muted
                loop
                playsInline
              />
              <video
                src="/videos/car_demo_2.mp4"
                className="mt-4 rounded-md h-24"
                autoPlay
                muted
                loop
                playsInline
              />
            </div>
          </Callout.Text>
        </Callout.Root>
      )}
    </>
  );
};
